/**
 * Pagination Types
 *
 * Shared pagination types for API requests and responses.
 */

/**
 * Standard pagination query parameters
 */
export interface PaginationQuery {
  /** Page number (1-indexed) */
  page?: number;
  /** Number of items per page */
  limit?: number;
}
